export default {
	0: {
		index: 0,
		poster: 'https://ufly-public.oss-cn-hangzhou.aliyuncs.com/course_news_img/baf2dcfc9c3734a9425d588104e897f.png',
		// title: '最近总觉得看东西模糊，我才35岁就老花了？',
		title: '不开刀 不配镜 改善老花眼',
		summary: '据《2023中国老花眼人群洞察报告》显示，我国35岁以上的人口中有老花眼问题人群占比高达56.9%，影响约3.9亿人。老花眼通常在38岁左右开始出现，绝大部分42-44岁出现，52岁以上人群老花眼的发病率接近100%。老花的专业名称叫“老视”，它是一种随年龄增长而发生的正常生理变化，也就是说，每个人最后都会得老花，只是时间早晚的问题——随着当今人们用眼习惯的改变（如长时间盯着电脑和手机看、熬夜、缺乏户外活动等），30多岁就出现老花的病例已经屡见不鲜。',
		date: '2024-10-23',
		content: `
		<h1 style=' font-size: 18px;text-align: center;font-weight:bold;color:#4692FF'>人人都会得老花</h1>
		<br/>
		<p>据《2023中国老花眼人群洞察报告》显示，<span style="color:#0080FF;font-weight:bold;">我国35岁以上的人口中有老花眼问题人群占比高达56.9%，影响约3.9亿人。</span> </p>
		<br/>
		<p>老花眼通常在38岁左右开始出现，绝大部分42-44岁出现，52岁以上人群老花眼的发病率接近100%。</p>
		<br/>
		<p>老花的专业名称叫“老视”，它是一种随年龄增长而发生的正常生理变化，也就是说，每个人最后都会得老花，只是时间早晚的问题——随着当今人们用眼习惯的改变（如长时间盯着电脑和手机看、熬夜、缺乏户外活动等），<span style="color:#0080FF;font-weight:bold;">30多岁就出现老花的病例已经屡见不鲜。</span> </p>
		<br/>
		<p style='text-align: center;'><img src='https://ufly-public.oss-cn-hangzhou.aliyuncs.com/course_news_img/311902ceca78f01853fca8c83d18d1c.png' style="width: 40%;"></p>
		<br/>
		<br/>
		<h1 style=' font-size: 18px;text-align: center;font-weight:bold;color:#4692FF'>近视和老花是无法互相抵消的。</h1>
		<br/>
		<p>这里我们要排除一个误区，很多朋友认为“已经近视了，就不会老花。”这个观念是错误的。</p>
		<br/>
			<p style='text-align: center;'><img src='https://ufly-public.oss-cn-hangzhou.aliyuncs.com/course_news_img/a0ac2d972969260e7a1a1502e7ff188.png' style="width: 40%;"></p>
			<br/>
			<p> <span style="color:#0080FF;font-weight:bold;">近视和老花是两种独立的屈光状态，它们的形成原理是截然不同的：</span> 近视通俗地讲就是平行光线进入眼内后无法聚焦在视网膜上，而是聚焦在视网膜之前，导致看不清远处的物体；而老花则是人眼因为晶状体变硬、肌肉肌力下降等原因，出现调节能力下降，导致无法顺畅完成“调焦”，使得看近处的物体时出现困难。</p>
		<br/>
		<br/>
			<h1 style=' font-size: 18px;text-align: center;font-weight:bold;color:#4692FF'>那有没有办法可以不戴老花镜或者延缓佩戴老花镜的年龄？</h1>
			<br/>
			<p>有些人群在不到四十岁就出现了老花趋势，主要是因为用眼过度或调节功能异常造成的，其在光线较暗时需要更强的照明，在阅读时也容易感到视疲劳，这将带来心理压力和焦虑情绪。</p>
			<br/>
			<p>也有些人群刚刚有了老花度数，一般在50度左右, 除了生活工作的不便外，还在为要不要佩戴老花镜而烦恼。</p>
			<br/>
			<p style='text-align: center;'><img src='https://ufly-public.oss-cn-hangzhou.aliyuncs.com/course_news_img/7874f2b91d99d2edb2b3eb1c55afc12.png' style="width: 40%;"></p>
			<br/>
			<p>如今一大批八零后如今已逐渐成为社会的“顶流”，作为家里的顶梁柱，单位里的掌舵人，他们挥斥方遒、壮怀激烈。</p>
			<br/>
			<p>但在不远的将来，他们都将加入老花的大家族，让他们戴老花镜十有八九都难以接受。但事实是残酷的，美容院可以保养皮肤，将白发染黑，但佩戴的老花镜却会让这些努力付之东流，是爱美女士的大敌。除非你很前卫选择通过手术治疗老花，不过这需要足够的勇气和大把的钞票。</p>
			<br/>
			<br/>
			<p style="font-size: 18px;font-weight: bold;">那有没有办法可以不戴老花镜或者延缓佩戴老花镜的年龄？</p>
			<br/>
			<p>有，“科飞神采”（一种抗老花老化调控视皮层的视知觉训练）来帮您训练！通过特定的视知觉训练任务，强制性调用大脑视觉神经细胞的参与，修复大脑皮层功能，加强大脑对视觉图像信息的解读能力，延缓老花，全面提升视觉质量。</p>
			<br/>
			<p>因为我们人眼能看到什么，是由我们的大脑最后决定的，眼睛结构虽然老花了、但大脑视觉神经通路终身重塑，大脑视觉功能提升了，我们的视力和视觉质量也得到了提升，可以有效延缓戴镜年龄。</p>
			<br/>
			<p ><img src='https://ufly-public.oss-cn-hangzhou.aliyuncs.com/course_news_img/baf2dcfc9c3734a9425d588104e897f.png' style="width: 100%;"></p>
			<br/>
			<p style="font-weight: bold;">参考文献：</p>
			<br/>
			<p style="color:#888888">1.Wolffsohn JS, Davies LN. Presbyopia: Effectiveness of correction strategies. Prog Retin Eye Res. 2019 Jan;68:124-143。</p>
			<br/>
			<p style="color:#888888">2.何海龙,常笛,陈淑莹,周春媛,王进达,万修华.老视治疗的研究进展[J].中华眼科杂志,2022,58(11):1000-1004.</p>
			<br/>
			<p style="color:#888888">3.Reinstein DZ, Ivory E, Chorley A, Archer TJ, Vida RS, Gupta R, Lewis T, Carp GI, Fonseca A, Parbhoo M. PRESBYOND Laser Blended Vision LASIK in Commercial and Military Pilots Requiring Class 1 Medical Certification. J Refract Surg. 2023 Jan;39(1):6-14.</p>
			
			`
	},
	1: {
		index: 1,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB01.jpg',
		title: '嗯，这很科飞！',
		summary: '中国科学技术大学生命科学学院研究员周逸峰研究小组与美国南加州大学心理学系教授吕忠林研究小组在实验中发现，成人弱视患者的视觉系统可塑性高于正常人。这一发现不仅为成人弱视患者提高视力带来了新希望，提供了理...',
		date: '2020-08-09 10:34:53',
		content: `
			<p>中国科学技术大学生命科学学院研究员周逸峰研究小组与美国南加州大学心理学系教授吕忠林研究小组在实验中发现，成人弱视患者的视觉系统可塑性高于正常人。这一发现不仅为成人弱视患者提高视力带来了新希望，提供了理论和实践依据，而且对大脑皮层可塑性的研究提供了新认识。弱视是指眼部无明显器质性病变，远视力低于0.8且不能矫正者。这一研究成果的论文于3月11日发表在美国《国家科学院院刊》（PNAS）上。</p>
			<p>据周逸峰介绍，在发育过程中，大脑神经系统细胞之间的连接是实现神经系统信息整合功能的基础，但这些细胞之间的连接并非一蹴而就或一成不变的。它们受到突触连接的活动历史和经验的调控。这种细胞连接被改变的可能性被称为“发育可塑性”，而这个“发育可塑性”有着被称为“关键期”的一个时间段。人们普遍认为，6岁到8岁前是空间视觉发育的关键期，3岁到5岁是音乐和听觉发育的关键期。也就是说，在相应关键期内，大脑很容易受到相应的外界环境和经验的影响。视觉系统的异常发育会导致弱视，弱视治疗与年龄密切相关，年龄越小，效果越好。很长一段时间以来，在弱视患者临床治疗中，8岁以后的弱视因错过了视觉发育的关键期，几乎没有有效的治疗措施。因为他们的视觉系统已不具备可塑性，难以用传统治疗手段恢复视力。</p>
			<p>然而，周逸峰和吕忠林领导的研究小组设计了一种实验，对成人弱视患者和正常人进行同样的空间视觉训练。一组为屈光参差性弱视患者，一组为正常人。在测量了两组被试者的视觉对比敏感度曲线以后，研究人员对他们在各自截止空间频率下训练，训练结束以后，再测试两组被试者的对比敏感度曲线。他们发现弱视患者的对比敏感度在训练后有显著提高，而正常人经过训练后变化较小。</p>
			<p>此外，他们还用一种叫做“高斯差”的数学模型拟合这些对比敏感度数据，并比较了屈光参差性弱视和正常对照知觉学习的空间频率带宽，发现弱视组的学习带宽为4.04±0.63 Octaves（倍频程，频率比率为2比1的两个频率的间隔），正常对照组的学习带宽为1.40±0.30 Octaves。这说明弱视患者视觉系统知觉学习的带宽比正常的视觉系统要大得多，显示弱视患者视觉系统与正常视觉系统相比有着更大的可塑性。因此，他们的研究为弱视患者的知觉学习治疗法提供了理论和实践依据。</p>
			<p>据有关医疗机构统计，目前，我国弱视发病率约为3%左右，成人弱视患者有3000万左右。周逸峰等人的研究结果如果能发展出相应的治疗方法，将有助于改善部分成人弱视患者的视力。</p>
			<p>这项研究工作是在中国国家自然科学基金委员会的资助下完成的。</p>
		`
	},
	2: {
		index: 2,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB02.jpg',
		title: '天津滨海新区妇幼保健服务中心学术交流会',
		summary: '7月6日，天津市滨海新区妇幼保健服务中心成功举办了关于弱视防治交流会。天津医科大学眼科医院斜视与小儿眼科中心主任钱学瀚和天津市眼科医院视光中心训练室主任江洋琳到中心进行学术交流，二人以幻灯片汇报的形...',
		date: '2018-07-10 14:59:16',
		content: `
			<p>7月6日，天津市滨海新区妇幼保健服务中心成功举办了关于弱视防治交流会。天津医科大学眼科医院斜视与小儿眼科中心主任钱学瀚和天津市眼科医院视光中心训练室主任江洋琳到中心进行学术交流，二人以幻灯片汇报的形式，介绍了关于儿童弱视危害和防预措施以及视知觉学习对于弱视治疗的重要作用。</p>
			<p>钱主任就儿童弱视危险因素及学前筛查的意义做出了重要报告，认为筛查对于可尽早发现造成弱视病症出现的早期危险因素有很重要意义，能够及早进行干预，从而减小病变对视功能发育的影响。做到可防可控的状态，大量减少儿童弱视的病变等危害可能。</p>
			<p>江主任针对视知觉学习治疗方法做了重点阐述，不仅介绍了视知觉学习治疗方法的定义，特点，疗效，还报告了使用视知觉学习治疗弱视的观察结果，该临床观察结果显示，视知觉学习法不仅能够显著提升弱视患者的矫正视力，更能够提升患者皮层性视觉功能中的光栅视力和二阶运动功能，有助于改善弱视患者的整体视觉功能。</p>
			<p>此次交流会中主要阐述了弱视危害和筛查意义，以及视知觉学习治疗方法对于救治弱视疾病的重大影响，会议全程对弱视治疗在临床上得到应用的最新科学的治疗方法做了完整汇报，让大家更深入的了解及接受视知觉学习治疗方法，是能够在临床上做到真正意义的帮助到更多弱视患者，最终确保患者能够及时接受正确、合适的医疗方法。</p>
			<p>妇幼保健中心各领导对此次学术交流格外重视，组织院内医护人员参加学习交流。此外，塘沽妇幼，汉沽妇幼，大港妇幼均有医生参加此次交流学习会。会议现场讨论一度达到高潮，氛围热烈。</p>
			<p>科飞视觉在此次交流会最后就视觉康复理念以及儿童视觉健康保护措施做了陈述报告，报告中提出，视觉功能的康复不仅包含眼部视功能的康复训练，更应该包括大脑皮层性视觉功能以及视觉认知功能的康复，才能达到整个视觉系统功能的全面康复提升。该观点得到了各主任专家的一致认可，并认为具有极强的可实施性以及大力推广度！</p>
		`
	},
	3: {
		index: 3,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB03.jpg',
		title: '热烈庆祝科飞视觉康复训练中心天津滨海新区（融科大厦...',
		summary: '2018年7月1号，在中国共产党建党97周年庆当天，科飞视觉康复训练中心天津市滨海新区融科大厦店盛大开业，正式起航！为感谢广大市民的大力支持,中心推出开业庆典活动。开业期间,到店即可享受专业全面的免费视觉健康体...',
		date: '2018-07-03 09:54:31',
		content: `
			<p>2018年7月1号，在中国共产党建党97周年庆当天，科飞视觉康复训练中心天津市滨海新区融科大厦店盛大开业，正式起航！为感谢广大市民的大力支持,中心推出开业庆典活动。开业期间,到店即可享受专业全面的免费视觉健康体检，包括验光、视功能检查、眼部检查及视觉健康相关咨询等项目。</p>
			<p>科飞视觉康复训练中心采用全套高档眼科及视光医用检查设备，从业人员均为天津医科大学及天津职业大学视光专业毕业，与医院视光门诊医师同等专业水准。此外，定期有眼科主任坐诊，解决疑难眼部疾病。</p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/2-1.jpg' style="width: 90%;"></p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/2-2.jpg' style="width: 90%;"></p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/2-3.jpg' style="width: 90%;"></p>
			<p><br/></p>
			<p>该视觉康复训练中心提供基本眼健康诊查、青少年近视防控、医学验光配镜、双眼视功能检查及视觉训练等眼保健服务。区别于一般视光中心，科飞视觉康复训练中心主要针对近视、远视、散光、老花等的专业医学配镜，以及儿童斜视弱视、阅读障碍、双眼视功能异常、视疲劳、视觉认知障碍等康复训练，此外还有白内障手术、准分子激光手术前后的屈光问题，如散光、眩光、对比敏感度下降、双眼视功能差等。该视觉康复中心功能全面，技能专业，可提供从眼部——视觉皮层——视觉认知的整个视觉系统功能的检测评估、方案制定、训练随访，是一家提供医学品质服务的专业中心店。</p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/2-4.jpg' style="width: 90%;"></p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/2-5.jpg' style="width: 90%;"></p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/2-6.jpg' style="width: 90%;"></p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/2-7.jpg' style="width: 90%;"></p>
			<p><br/></p>
			<p style='text-indent: 0em;'>科飞视觉康复训练中心的建立，旨在为广大市民提供专业、优质、便捷的视觉康复服务。该中心开业期间举行以下特惠活动：</p>
			<p style='text-indent: 0em;'>1.到店即可享受免费视觉健康体检，包括验光、眼部检查、视功能检查、皮层性视觉功能检查等</p>
			<p style='text-indent: 0em;'>2.享受8.8折配镜优惠</p>
			<p style='text-indent: 0em;'>3.购买训练项目即赠送价值800元的训练套餐</p>
			<p><br/></p>
			<p style='text-indent: 0em;'>地址：天津市滨海新区二大街融科大厦101—102</p>
			<p style='text-indent: 0em;'>联系方式：15822169411</p>
		`
	},
	4: {
		index: 4,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB04.jpg',
		title: '中国科大周逸峰挑战眼疾禁区——成人弱视，希望犹存',
		summary: '成人弱视是由于眼视功能发育延缓或延迟导致，12岁以后视功能基本不再发育，故成人弱视很难治疗，没有好的治疗方法，需要长期戴眼镜矫正。有条件的话可以尝试“视觉脑感知训练”对部分成人弱视有点效果。 中国科大生...',
		date: '2017-03-31',
		content: `
			<p>成人弱视是由于眼视功能发育延缓或延迟导致，12岁以后视功能基本不再发育，故成人弱视很难治疗，没有好的治疗方法，需要长期戴眼镜矫正。有条件的话可以尝试“视觉脑感知训练”对部分成人弱视有点效果。</p>
			<p>中国科大生命科学学院的周逸峰教授作为论文的第一作者，与中国科技大学校友、美国南加州大学吕忠林教授合作开发出一种治疗成人弱视的可能方法，发表于最新一期的《视觉研究》上。2006年1月3日发行的美国《纽约时报》以《成人弱视，希望犹存》为题对该项成果进行了新闻报道。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/3-1.png'></p>
			<p>由于传统遮盖治疗方法在大龄儿童及成人弱视患者效果非常不理想，长久以来，在弱视临床研究领域，人们对8岁以后的弱视(在8岁前治疗失败或未得到有效治疗者)几乎不采取任何治疗措施。弱视如得不到有效治疗，则可引起永久性视觉损失。</p>
			<p>《纽约时报》的文章指出，弱视的机制至今尚不清楚。一般认为其与发育早期的异常视觉经验相关，如斜视或屈光参差等。治疗多采用遮盖相对健眼来提高弱视眼视觉功能。人们一直认为，视觉系统相关区域在发育关键期以后不再具有“可塑性”或“可塑性”显著降低，因此，在临床上，对8岁以后的弱视几乎不采取任何治疗措施。但研究者们认为事实可能并非如此——“弱视治疗的年龄界限可能并非像我们以前所认为的那样确定”。</p>
			<p>吕忠林教授告诉《纽约时报》记者，他们选取了23名成人弱视被试者(平均年龄19.3岁)并将其随机分成3组。通过计算机呈现特定的刺激，用不同方法训练其中两组被试者以提高他们的对比度知觉能力。训练持续从9到19天不等。尽管对比敏感度只是视觉系统众多功能之一，但研究者发现，经过训练以后，成人弱视患者的字母矫正视力平均提高70%。对照组则没有表现出相似提高。</p>
		`
	},
	5: {
		index: 5,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB05.jpg',
		title: '视觉系统可塑性高为矫治成年弱视带来新希望',
		summary: '中国科学技术大学生命科学学院研究员周逸峰研究小组与美国南加州大学心理学系教授吕忠林研究小组在实验中发现，成人弱视患者的视觉系统可塑性高于正常人。日前，周逸峰向记者表示，这一发现为成年弱视患者视力矫治...',
		date: '2017-03-31',
		content: `
			<p>中国科学技术大学生命科学学院研究员周逸峰研究小组与美国南加州大学心理学系教授吕忠林研究小组在实验中发现，成人弱视患者的视觉系统可塑性高于正常人。日前，周逸峰向记者表示，这一发现为成年弱视患者视力矫治提供了理论和实践依据，为其提高视力带来了新希望；而且为人类大脑皮层可塑性的研究提供了新认识。这一研究成果的论文已于2006年发表在《美国科学院院刊》上。</p>
			<p> 据周逸峰介绍，弱视患者是指眼部无明显器质性病变，远视力低于0.8且不能矫正者。人体在发育过程中，大脑神经系统的细胞之间连接是实现神经系统信息整合功能的基础，但这些细胞之间的连接并非“一蹴而就”或一成不变，它们受到突触连接的活动历史和经验的调控。这种细胞连接被改变的可能性被称为“发育可塑性”，而这个“发育可塑性”有着被称为“关键期”的一个时间段。</p>
			<p>他说：迄今为止，科学界普遍认为，人在6岁到8岁前是空间视觉发育的关键期。也就是说，在相应的关键期内，大脑很容易受到相应的外界环境和经验的影响。视觉系统的异常发育会导致弱视，弱视治疗与年龄密切相关，年龄越小，效果越好。所以，很长一段时间以来，在弱视患者的临床治疗中，8岁以后的弱视患者因为错过了视觉发育的关键期，视觉系统已不具备可塑性，难以用传统的治疗手段恢复视力，所以几乎没有有效的治疗措施。</p>
			<p>然而，周逸峰和吕忠林领导的研究小组设计了一种实验，对成人弱视患者和正常人进行了同样的空间视觉训练。被试者，一组为屈光参差性弱视患者，另一组为正常人。在测量了两组被试者的视觉对比敏感度曲线以后，研究人员对他们在各自截止空间频率下训练，训练结束以后，再测试两组被试者的对比敏感度曲线。他们发现弱视患者的对比敏感度在训练后有显著提高，而正常人经过训练后变化较小。</p>
			<p> 此外，他们还用一种叫做“高斯差”的数学模型拟合这些对比敏感度数据，并比较了屈光参差性弱视和正常对照知觉学习的空间频率带宽，发现弱视组的学习带宽数据是正常对照组的2.5倍以上。这说明，弱视患者视觉系统知觉学习的带宽比正常人的视觉系统要大得多；显示了弱视患者视觉系统与正常人视觉系统相比，有着更大的可塑性。因此，他们的研究为成年弱视患者的知觉学习治疗法提供了理论和实践依据。</p>
			<p>据有关医疗机构统计，目前，我国弱视发病率约为3％左右，全国有成年弱视患者3000万人左右。周逸峰等人的研究结果如果能开发出相应的治疗方法，将有助于改善部分成年弱视患者的视力。</p>
		`
	},
	6: {
		index: 6,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB06.jpg',
		title: '省暨合肥市举办纪念中国计生协会成立35周年宣传服务活...',
		summary: '今年5月29日是中国计生协成立35周年和安徽省计生协成立30周年纪念日，也是全国计生协第十七个“会员活动日”。5月28日上午，省暨合肥市在瑶海区和平广场举办“生育关怀•幸福家庭”宣传服务活动，倡导婚育新风、体...',
		date: '2015-05-30',
		content: `
			<p>今年5月29日是中国计生协成立35周年和安徽省计生协成立30周年纪念日，也是全国计生协第十七个“会员活动日”。5月28日上午，省暨合肥市在瑶海区和平广场举办“生育关怀•幸福家庭”宣传服务活动，倡导婚育新风、体现生育关怀、建设幸福家庭，把协会工作更加有声有色地开展起来。此次活动由省计生协、省人口基金会、合肥市计生协主办，瑶海区区委、区政府承办，明光路街道党工委、办事处协办。省卫生计生委党组副书记、副主任、省计生协常务副会长杨武、合肥市副市长王翔等有关领导应邀出席，省、市计生协、省人口基金会、合肥市所辖县（市、区）计生协负责人、部分街道、社区计生协工作者，计生协会员代表和志愿者代表共500多人参加活动。</p>
			<p>合肥科飞视觉科技有限公司热心公益，总经理汤勇作为捐赠代表上台发言，向广大群众进行弱视知识的科普，表达了科飞公司希望每一位弱视患儿都能得到有效治疗的美好愿景。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/5-1.png'></p>
			<p> 同时，科飞公司为合肥全市及下属各县捐赠了共计260份弱视治疗软件套装。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/5-2.png'></p>
			<p>2015年起，科飞公司与安徽省计划生育协会合作开展了“点亮工程”项目，拟在六年内向全省的弱视少年儿童捐赠服务套装共计2000份。2015年将为1000名弱视儿童提供3个月的康复服务，在十三五期间（2016-2020年），每年服务200人，五年共服务1000名弱视儿童。</p>
			<p>科飞鹰眼是合肥科飞视觉科技有限公司针对弱视患者推出的治疗性产品。鹰眼遵循“循序渐进，从简单到复杂，从低级到高级”的弱视康复原则，基于最新的科研成果，提出了“四条核心康复理念”和“十大类康复指标”，可实现高效全面的弱视康复。科飞鹰眼具有以下特点：是目前唯一可治疗成人弱视的方法；可独立使用，也可联合遮盖法同时使用；无心理、生理方面副作用；远程服务，操作方便，交互性强等。</p>
		`
	},
	7: {
		index: 7,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB07.jpg',
		title: '高新区纪念计划生育协会成立35周年社区文艺演出，科飞...',
		summary: '为了进一步做好计划生育优质服务进社区工作，以群众喜闻乐见的形式，把计生工作融入到社区和家庭，以计生协会成立35周年为契机，以创建省级绿色文明社区为载体，通过群众广场文艺演出、互动交流等形式宣传计生政策...',
		date: '2015-05-24 09:42:41',
		content: `
			<p>为了进一步做好计划生育优质服务进社区工作，以群众喜闻乐见的形式，把计生工作融入到社区和家庭，以计生协会成立35周年为契机，以创建省级绿色文明社区为载体，通过群众广场文艺演出、互动交流等形式宣传计生政策，充分展现社区“融洽邻里，凝聚人心、倡导绿色”的社会氛围和社区建设整体联动、共驻共建的良好局面，通过以不同的文艺方式宣传，扩大知晓率，提高满意率。高新区天乐社区服务中心蜀峰湾社区决定举办以“生育关怀，绿色社区”为主题的纪念计划生育协会成立35周年暨创建省级绿色社区广场文艺演出活动。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/6-1.png'></p>
			<p>5月23日上午，活动在澜溪镇小区拉开帷幕。活动中，高新区的弱视儿童家长代表上台领取了科飞视觉公司捐赠的弱视训练软件。科飞公司为弱视儿童能得到科学有效的治疗尽一份力，提高儿童视力，提高人口质量，是科飞公司回报社会热心公益的体现。</p>
			<p>随后，社区的居民们和各级领导们观看了精彩纷呈的文艺汇演，整场活动在热烈的气氛中圆满结束。</p>
			<p><br/></p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/6-2.png'></p>
		`
	},
	8: {
		index: 8,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB08.jpg',
		title: '蜀山区庆祝“5.29”计生协会成立35周年，科飞视觉捐赠...',
		summary: '4月22日-5月22日上午，蜀山区庆祝“5.15”国际家庭日成立22周年，“5.29”计生协会成立35周年，“和谐家庭·幸福守望”文艺汇演活动在蜀山区天鹅湖万达广场隆重展开。 活动上，合肥科飞视觉科技有限公司总经理汤勇上...',
		date: '2015-05-23',
		content: `
			<p>4月22日-5月22日上午，蜀山区庆祝“5.15”国际家庭日成立22周年，“5.29”计生协会成立35周年，“和谐家庭·幸福守望”文艺汇演活动在蜀山区天鹅湖万达广场隆重展开。</p>
			<p>活动上，合肥科飞视觉科技有限公司总经理汤勇上台发言，宣传了弱视的科普知识，弱视的治疗方式等，并表达了科飞公司希望给予弱视儿童健康科学有效治疗的美好愿景。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/7-1.png'></p>
			<p>讲话过后，蜀山区计生协安排了弱视家长代表上台领取了“科飞鹰眼”弱视治疗软件套装，切实让每一位弱视儿童得到科学有效的治疗。</p>
			<p>合肥科飞视觉科技有限公司热心社会公益事业，关注青少年儿童视力健康，特捐赠科飞鹰眼弱视训练套装，与安徽省计生协、人口基金会合作开展“点亮工程”项目，为全省弱视儿童免费提供弱视的康复训练。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/7-2.png'></p>
			<p>在活动的后半程，区计生协安排了精彩纷呈的文艺汇演，活动圆满落幕。</p>
		`
	},
	9: {
		index: 9,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB09.jpg',
		title: '科飞视觉参加先进技术研究院2015年科技活动周，展示视...',
		summary: '5月16日上午，合肥科飞视觉科技有限公司参加了中国科学技术大学先进技术研究2015年科技活动周，在先进技术研究院未来中心大厅以及科学技术大学东区设置了两个科普点，向全体参观的市民展示了视知觉学习训练治疗弱视...',
		date: '2015-05-18',
		content: `
			<p>5月16日上午，合肥科飞视觉科技有限公司参加了中国科学技术大学先进技术研究2015年科技活动周，在先进技术研究院未来中心大厅以及科学技术大学东区设置了两个科普点，向全体参观的市民展示了视知觉学习训练治疗弱视的技术。</p>
			<p>此次参观的除了合肥市区的民众，还有来自宿州、六安、临泉、萧县的中小学校的众多学生，在老师和志愿者的组织下远道而来，参加科技周活动。科飞视觉展示了能够利用特殊图形进行训练从而提高视力的科飞鹰眼软件，同时，提供了可穿戴的3D眼镜，让参观的民众们切身感受了一次3D训练。</p>
		`
	},
	10: {
		index: 10,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB10.jpg',
		title: '安徽省计生协、人口基金工作暨培训会召开，科飞视觉点...',
		summary: '4月22日-23日，安徽省计生协、安徽省人口基金会在合肥市召开2015年安徽省计生协、人口基金工作暨培训会。会议总结部署了计生协及人口基金工作，并向154名省人口基金会项目官员颁发了聘书，会议还就人口基金项目管理...',
		date: '2015-04-29',
		content: `
			<p>4月22日-23日，安徽省计生协、安徽省人口基金会在合肥市召开2015年安徽省计生协、人口基金工作暨培训会。会议总结部署了计生协及人口基金工作，并向154名省人口基金会项目官员颁发了聘书，会议还就人口基金项目管理和资金管理做了培训。安徽省卫生计生委党组副书记、副主任、安徽省计生协常务副会长、安徽省人口基金会监事长杨武，安徽省卫生计生委党组成员、副主任朱庆，安徽省人口基金会理事长李天太、副理事长牛和桂等出席会议并讲话。安徽省直计生协有关人员、各市计生协副会长（委分管副主任）和秘书长、各县（市、区）计生协秘书长和财务工作人员参加了工作暨培训会。</p>
			<p>会议还邀请了相关人就点亮工程、暖心工程和优生优育保险等2015年新项目作说明。其中，合肥科飞视觉科技有限公司运营总监汤勇就点亮工程做了详细的介绍。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/9-1.png'></p>
			<p><br/></p>
			<p>合肥科飞视觉科技有限公司热心社会公益事业，关注青少年儿童视力健康，特捐赠科飞鹰眼弱视训练套装，与安徽省计生协、人口基金会合作开展“点亮工程”项目，为全省弱视儿童免费提供弱视的康复训练。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/9-2.png'></p>
			<p>科飞视觉捐赠的科飞鹰眼服务是一种互联网医疗服务。弱视患者获得授权后，可使用授权信息在家中通过个人计算机和互联网登录科飞视觉的服务器，接受远程服务，实现弱视康复。在点亮工程的六年内，科飞视觉拟向安徽省内弱视少年儿童捐赠服务套装共计2000份，每份均包含服务的授权信息、使用指南和相关的参考资料。其中，授权信息可为用户提供三个月共计90天的弱视康复服务。使用指南和参考资料可帮助弱视患者科学地理解弱视的康复方法和相关概念。</p>
			<p>活动包括弱视的诊断和咨询服务、弱势的远程训练服务以及线下培训和在线客服。活动的弱视筛查工作将于5月1日起在全安徽省范围内展开，一直持续到6月初，随后将进行相关培训、服务督导等工作。</p>
			<p>“点亮工程”活动的开展将会为安徽省内的弱视儿童提供更加科学有效便捷的治疗。</p>
		`
	},
	11: {
		index: 11,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB11.jpg',
		title: '科飞视觉向安徽省人口基金会捐赠百万诊疗服务',
		summary: '2014年11月21日上午，合肥科飞视觉科技有限公司、科大讯飞股份有限公司、安徽省人口基金会和安徽省计划生育协会共同举办了“暖心工程”和“点亮工程”捐赠仪式。会上科飞视觉与科大讯飞共同为安徽计生特扶家庭与弱...',
		date: '2014-12-01',
		content: `
			<p>2014年11月21日上午，合肥科飞视觉科技有限公司、科大讯飞股份有限公司、安徽省人口基金会和安徽省计划生育协会共同举办了“暖心工程”和“点亮工程”捐赠仪式。会上科飞视觉与科大讯飞共同为安徽计生特扶家庭与弱视少年儿童共捐助价值760万元的产品及服务。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/10-1.png'></p>
			<p>专注于恢复弱视患者视力的企业科飞视觉在捐赠会上向安徽省内2000名弱视少年儿童捐赠了价值360万元的远程弱视康复服务。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/10-2.png'></p>
			<p style='text-align: center;'>科飞视觉董事长周逸峰与安徽省人口基金会签署合约</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/10-3.png'></p>
			<p style='text-align: center;'>科飞视觉董事长周逸峰和安徽省计划生育协会签署合约</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/10-4.png'></p>
		`
	},
	12: {
		index: 12,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB12.jpg',
		title: '国家卫生和计划生育委员会主任李斌调研先进技术研究院',
		summary: '2014年6月8日下午，国家卫生和计划生育委员会主任李斌来到中国科学技术大学先进技术研究院，调研园区建设、项目建设及运行情况。安徽省委常委、常务副省长詹夏来，安徽省委常委、副省长陈树隆，安徽省委常委、合肥...',
		date: '2014-06-09',
		content: `
			<p>2014年6月8日下午，国家卫生和计划生育委员会主任李斌来到中国科学技术大学先进技术研究院，调研园区建设、项目建设及运行情况。安徽省委常委、常务副省长詹夏来，安徽省委常委、副省长陈树隆，安徽省委常委、合肥市委书记吴存荣，中国科大党委书记许武、校长侯建国，合肥市市长张庆军，以及省政府办公厅、省卫生厅、合肥市高新区有关负责人，中国科大相关部门负责人陪同调研。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/11-1.png'></p>
			<p>在未来中心大楼一楼大厅，李斌主任一行观看了先研院建设宣传片，了解了相关项目。之后，李斌主任来到科教创新展厅，调研先研院研发中心的阶段性成果与产品。</p>
			<p>在我公司的基于云计算的交互式知觉训练系统科技展台前，李斌主任认真听取了公司人员的介绍和汇报，并仔细询问科技成果的原理、应用及产业化状况。李斌主任对该项目表示了高度的肯定和赞赏。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/11-2.png'></p>
			<p><br/></p>
			<p>相关链接：<a href='http://news.ustc.edu.cn/xwbl/201406/t20140609_197203.html' style='color: #428bca;'>http://news.ustc.edu.cn/xwbl/201406/t20140609_197203.html</a></p>
		`
	},
	13: {
		index: 13,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB13.jpg',
		title: '国家卫生和计划生育委员会主任李斌到先进技术研究院调...',
		summary: '2013年3月22日，国家卫生和计划生育委员会主任李斌到先进技术研究院调研工作，实地考察了先进技术研究院的园区建设进展情况及最新研究成果。陪同调研的还有安徽省省委常委、常务副省长詹夏来；省委常委、副省长陈树...',
		date: '2013-03-22',
		content: `
			<p>2013年3月22日，国家卫生和计划生育委员会主任李斌到先进技术研究院调研工作，实地考察了先进技术研究院的园区建设进展情况及最新研究成果。陪同调研的还有安徽省省委常委、常务副省长詹夏来；省委常委、副省长陈树隆；省委常委、合肥市委书记吴存荣；省政府秘书长韩先聪；合肥市市长张庆军；安徽省教育厅厅长程艺科、科技厅厅长徐根应；中科院合肥物质科学研究院党委书记匡光力、院长王英俭、高新区管委会主任李兵及中国科大党委书记许武、校长侯建国、副校长陈晓剑等。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/12-1.png'></p>
			<p>在调研过程中，李斌主任参观了“网络化交互式视知觉训练系统”。该系统是以中国科大生命科学院与信息学院的两名在校博士生为主的团队研发的成果，能通过简单有趣的方式大幅提升弱视患者的视力。在得知两名博士生计划通过该项目，推动建立“弱视医疗云计算中心”和“国人弱视样本库”，并采取博士生志愿者服务等形式，促进“视知觉治疗进基层”工程实施，李斌主任表示了高度的肯定和赞赏，认为此项工作很有意义，并表示在适当的时候推动此项成果与国家医保项目对接。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/12-2.png'></p>
		`
	},
	14: {
		index: 14,
		poster: 'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E6%96%B0%E9%97%BB14.jpg',
		title: '中国科大先进技术研究院举办首届先进技术与资本推介会...',
		summary: '2013年1月29日上午，中国科学技术大学先进技术研究院首届先进技术和资本推介会在合肥隆重举行。中国科大校长侯建国，合肥市委常委、副市长韩冰，中国科大副校长陈晓剑、共青团安徽省委副书记周密、中科院自动化所所...',
		date: '2013-01-30',
		content: `
			<p>2013年1月29日上午，中国科学技术大学先进技术研究院首届先进技术和资本推介会在合肥隆重举行。中国科大校长侯建国，合肥市委常委、副市长韩冰，中国科大副校长陈晓剑、共青团安徽省委副书记周密、中科院自动化所所长王东琳，以及省市有关部门负责同志出席会议。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/13-1.png'></p>
			<p>来自美国、英国等国外和国内的48家投资商，以及先进技术研究院组织的68个研发项目负责人参加了本次推介会，68个项目中，来自中国科大系统以外的超过三分之一。十多家媒体现场进行了采访报道。推介会现场气氛热烈，与会人数远远超出计划，达200多人，会场爆满，过道及门口处站满与会者。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/13-2.png'></p>
			<p>会上，中国科大生命科学学院博士生王潇潇介绍了网络化交互式视知觉训练系统，该系统是以中国科大生命科学院与信息学院的两名在校博士生为主的团队研发的成果，能通过简单有趣的方式大幅提升弱视患者的视力。</p>
			<p style='text-align: center;'><img src='http://ufly-eagledr-img-lib.oss-cn-hangzhou.aliyuncs.com/guanwang/13-3.png'></p>
		`
	},

}